export const MIN_NOTIFICATION_THRESHOLD_MINUTES = 1;
export const MAX_NOTIFICATION_THRESHOLD_MINUTES = 180;

export function normalizeCustomNotificationThreshold(value) {
  const text = String(value ?? '').trim();
  if (!text) return null;

  const threshold = Number(text);
  if (!Number.isInteger(threshold)) return null;
  if (threshold < MIN_NOTIFICATION_THRESHOLD_MINUTES || threshold > MAX_NOTIFICATION_THRESHOLD_MINUTES) return null;
  return threshold;
}
